module.exports = __webpack_public_path__ + "img/error.f8a41688.svg";